// counter.actions.ts
import { Action } from '@ngrx/store';

export const FETCH_PLATFORM_INFO = '[Platform] FETCH_PLATFORM_INFO';
export const FETCH_PLATFORM_INFO_SUCCESS = '[Platform] FETCH_PLATFORM_INFO_SUCCESS';
export const FETCH_PLATFORM_INFO_FAILURE = '[Platform] FETCH_PLATFORM_INFO_FAILURE';
export const RESET_PLATFORM_INFO = '[Platform] RESET_PLATFORM_INFO';

export class ResetPlatformInfo implements Action {
  readonly type = RESET_PLATFORM_INFO;
  constructor() { }
}

export class FetchPlatformInfo implements Action {
  readonly type = FETCH_PLATFORM_INFO;
  constructor() { }
}

export class FetchPlatformInfoSuccess implements Action {
  readonly type = FETCH_PLATFORM_INFO_SUCCESS;
  constructor(public payload: any) {
  }
}

export class FetchPlatformInfoFailure implements Action {
  readonly type = FETCH_PLATFORM_INFO_FAILURE;
  constructor(public payload: any) {
  }
}

export type Actions = ResetPlatformInfo | FetchPlatformInfo | FetchPlatformInfoSuccess | FetchPlatformInfoFailure;



// WEBPACK FOOTER //
// ./src/actions/platform.actions.ts